// import {
//   Box,
//   Typography,
//   Paper,
//   Avatar,
//   Button,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Switch,
//   Divider,
//   IconButton,
//   TextField,
//   Collapse,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import CloseIcon from "@mui/icons-material/Close";
// import NotificationsIcon from "@mui/icons-material/NotificationsNoneOutlined";
// import LanguageIcon from "@mui/icons-material/LanguageOutlined";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
// import VegIcon from "@mui/icons-material/GrassOutlined";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import DownloadIcon from "@mui/icons-material/Download";
// import InstallMobileIcon from "@mui/icons-material/InstallMobile";
// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { selectRestaurantInfo } from "../../../redux/slices/publicSlice";

// // Sub-pages
// import HelpSupportPage from "./HelpSupportPage";
// import RateAppPage from "./RateAppPage";
// import AboutPage from "./AboutPage";

// const STORAGE_KEY = "digital_manu_user_profile";
// const VEG_MODE_KEY = "digital_manu_veg_only";

// const AccountPage = ({ restaurantId, onSubPageChange }) => {
//   const restaurantInfo = useSelector(selectRestaurantInfo);

//   // ── PWA Install State ──
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [showInstallBanner, setShowInstallBanner] = useState(false);
//   const [installSuccess, setInstallSuccess] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//   // Check if app is already installed
//   const [isAppInstalled, setIsAppInstalled] = useState(false);

//   useEffect(() => {
//     // Check if app is installed (PWA)
//     if (window.matchMedia('(display-mode: standalone)').matches) {
//       setIsAppInstalled(true);
//     }

//     // Listen for beforeinstallprompt event
//     const handler = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setShowInstallBanner(true);
//     };

//     window.addEventListener('beforeinstallprompt', handler);

//     // Listen for app installed event
//     const installedHandler = () => {
//       setIsAppInstalled(true);
//       setShowInstallBanner(false);
//       setSnackbarMessage("App installed successfully! 🎉");
//       setSnackbarSeverity("success");
//       setSnackbarOpen(true);
//     };

//     window.addEventListener('appinstalled', installedHandler);

//     return () => {
//       window.removeEventListener('beforeinstallprompt', handler);
//       window.removeEventListener('appinstalled', installedHandler);
//     };
//   }, []);

//   const handleInstall = async () => {
//     if (!deferredPrompt) {
//       // Fallback for iOS or browsers that don't support beforeinstallprompt
//       setSnackbarMessage("Please use 'Add to Home Screen' from your browser menu");
//       setSnackbarSeverity("info");
//       setSnackbarOpen(true);
//       return;
//     }

//     try {
//       // Show the install prompt
//       deferredPrompt.prompt();
      
//       // Wait for the user to respond
//       const { outcome } = await deferredPrompt.userChoice;
      
//       if (outcome === 'accepted') {
//         setInstallSuccess(true);
//         setShowInstallBanner(false);
//         setSnackbarMessage("App installed successfully! 🎉");
//         setSnackbarSeverity("success");
//       } else {
//         setSnackbarMessage("Installation cancelled");
//         setSnackbarSeverity("info");
//       }
      
//       setDeferredPrompt(null);
//       setSnackbarOpen(true);
//     } catch (error) {
//       console.error('Install error:', error);
//       setSnackbarMessage("Unable to install. Please try from browser menu");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//     }
//   };

//   const handleDismissBanner = () => {
//     setShowInstallBanner(false);
//   };

//   // ── Profile State ──
//   const [profile, setProfile] = useState(() => {
//     try {
//       const saved = localStorage.getItem(STORAGE_KEY);
//       return saved ? JSON.parse(saved) : { name: "", phone: "", address: "" };
//     } catch {
//       return { name: "", phone: "", address: "" };
//     }
//   });

//   const [editing, setEditing] = useState(false);
//   const [draft, setDraft] = useState(profile);
//   const [vegOnly, setVegOnly] = useState(() => {
//     try {
//       const saved = localStorage.getItem(VEG_MODE_KEY);
//       return saved ? JSON.parse(saved) : false;
//     } catch {
//       return false;
//     }
//   });
//   const [notifications, setNotifs] = useState(false);

//   // Sub-page routing
//   const [activePage, setActivePage] = useState(null);

//   const openSubPage = (page) => {
//     setActivePage(page);
//     onSubPageChange?.(page, closeSubPage);
//   };
//   const closeSubPage = () => {
//     setActivePage(null);
//     onSubPageChange?.(null);
//   };

//   const handleSave = () => {
//     setProfile(draft);
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
//     setEditing(false);
//   };

//   const initials = profile.name
//     ? profile.name
//         .split(" ")
//         .map((n) => n[0])
//         .join("")
//         .toUpperCase()
//         .slice(0, 2)
//     : "?";

//   const SettingRow = ({ icon, label, action, divider = true }) => (
//     <>
//       <ListItem sx={{ px: 0, py: 1.2 }}>
//         <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
//         <ListItemText
//           primary={
//             <Typography
//               variant="body2"
//               sx={{ fontSize: "0.85rem", fontWeight: 500, color: "#333" }}
//             >
//               {label}
//             </Typography>
//           }
//         />
//         {action}
//       </ListItem>
//       {divider && <Divider sx={{ ml: 4.5 }} />}
//     </>
//   );

//   // ── Sub-page render ──
//   if (activePage === "help") return <HelpSupportPage onBack={closeSubPage} />;
//   if (activePage === "rate") return <RateAppPage onBack={closeSubPage} />;
//   if (activePage === "about") return <AboutPage onBack={closeSubPage} />;

//   return (
//     <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 2 }}>
//       {/* ── Install App Banner ── */}
//       {showInstallBanner && !isAppInstalled && (
//         <Paper
//           elevation={2}
//           sx={{
//             mx: 2,
//             mt: 2,
//             p: 1.5,
//             borderRadius: 2,
//             bgcolor: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
//             border: "1px solid #FF6B0033",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: 1,
//             background: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <InstallMobileIcon sx={{ color: "white", fontSize: 28 }} />
//             <Box>
//               <Typography
//                 sx={{
//                   color: "white",
//                   fontWeight: 700,
//                   fontSize: "0.85rem",
//                 }}
//               >
//                 Install Digital Menu App
//               </Typography>
//               <Typography
//                 sx={{
//                   color: "rgba(255,255,255,0.8)",
//                   fontSize: "0.7rem",
//                 }}
//               >
//                 Get faster access & offline support
//               </Typography>
//             </Box>
//           </Box>
//           <Box sx={{ display: "flex", gap: 0.5 }}>
//             <Button
//               size="small"
//               onClick={handleDismissBanner}
//               sx={{
//                 color: "rgba(255,255,255,0.7)",
//                 minWidth: "auto",
//                 p: 0.5,
//                 "&:hover": { color: "white" },
//               }}
//             >
//               <CloseIcon sx={{ fontSize: 18 }} />
//             </Button>
//             <Button
//               variant="contained"
//               size="small"
//               onClick={handleInstall}
//               startIcon={<DownloadIcon />}
//               sx={{
//                 bgcolor: "white",
//                 color: "#FF6B00",
//                 fontWeight: 700,
//                 fontSize: "0.75rem",
//                 textTransform: "none",
//                 borderRadius: 2,
//                 "&:hover": {
//                   bgcolor: "#f5f5f5",
//                 },
//               }}
//             >
//               Install
//             </Button>
//           </Box>
//         </Paper>
//       )}

//       {/* ── Profile Card ── */}
//       <Box
//         sx={{
//           bgcolor: "white",
//           px: 2,
//           pt: 3,
//           pb: 3,
//           borderBottom: "1px solid #f0f0f0",
//           mt: showInstallBanner && !isAppInstalled ? 1 : 0,
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//           <Avatar
//             sx={{
//               width: 60,
//               height: 60,
//               bgcolor: "#2e7d32",
//               fontSize: "1.3rem",
//               fontWeight: 700,
//             }}
//           >
//             {initials}
//           </Avatar>
//           {!editing ? (
//             <Box sx={{ flex: 1 }}>
//               <Typography
//                 variant="subtitle1"
//                 sx={{ fontWeight: 700, fontSize: "1rem" }}
//               >
//                 {profile.name || "Set your name"}
//               </Typography>
//               {profile.phone && (
//                 <Typography variant="caption" sx={{ color: "#888" }}>
//                   {profile.phone}
//                 </Typography>
//               )}
//               <Box>
//                 {profile.address && (
//                   <Typography variant="caption" sx={{ color: "#888" }}>
//                     {profile.address}
//                   </Typography>
//                 )}
//               </Box>
//             </Box>
//           ) : (
//             <Box
//               sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}
//             >
//               <TextField
//                 size="small"
//                 placeholder="Your name"
//                 value={draft.name}
//                 onChange={(e) => setDraft({ ...draft, name: e.target.value })}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     fontSize: "0.85rem",
//                     "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
//                   },
//                 }}
//               />
//               <TextField
//                 size="small"
//                 placeholder="Phone number"
//                 value={draft.phone}
//                 onChange={(e) => setDraft({ ...draft, phone: e.target.value })}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     fontSize: "0.85rem",
//                     "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
//                   },
//                 }}
//               />
//               <TextField
//                 size="small"
//                 placeholder="Your Address"
//                 value={draft.address}
//                 onChange={(e) =>
//                   setDraft({ ...draft, address: e.target.value })
//                 }
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     fontSize: "0.85rem",
//                     "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
//                   },
//                 }}
//               />
//             </Box>
//           )}
//           {!editing ? (
//             <IconButton
//               size="small"
//               onClick={() => {
//                 setEditing(true);
//                 setDraft(profile);
//               }}
//               sx={{ bgcolor: "#f5f5f5", "&:hover": { bgcolor: "#ebebeb" } }}
//             >
//               <EditIcon sx={{ fontSize: 18, color: "#555" }} />
//             </IconButton>
//           ) : (
//             <Box sx={{ display: "flex", gap: 0.5 }}>
//               <Button
//                 size="small"
//                 onClick={() => {
//                   setEditing(false);
//                   setDraft(profile);
//                 }}
//                 sx={{
//                   borderRadius: 1.5,
//                   textTransform: "none",
//                   color: "#888",
//                   fontSize: "0.78rem",
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 size="small"
//                 variant="contained"
//                 onClick={handleSave}
//                 sx={{
//                   borderRadius: 1.5,
//                   bgcolor: "#2e7d32",
//                   "&:hover": { bgcolor: "#1b5e20" },
//                   textTransform: "none",
//                   fontSize: "0.78rem",
//                 }}
//               >
//                 Save
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Box>

//       {/* ── Preferences ── */}
//       <Box sx={{ mx: 2, mt: 2 }}>
//         <Typography
//           variant="caption"
//           sx={{
//             color: "#aaa",
//             fontWeight: 700,
//             fontSize: "0.7rem",
//             textTransform: "uppercase",
//             letterSpacing: 0.8,
//             mb: 0.8,
//             display: "block",
//           }}
//         >
//           Preferences
//         </Typography>
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: 2.5,
//             bgcolor: "white",
//             border: "1px solid #f0f0f0",
//             px: 1.5,
//           }}
//         >
//           <List disablePadding>
//             <SettingRow
//               icon={<VegIcon sx={{ fontSize: 20, color: "#2e7d32" }} />}
//               label="Veg Only Mode"
//               action={
//                 <Switch
//                   size="small"
//                   checked={vegOnly}
//                   onChange={(e) => {
//                     const value = e.target.checked;
//                     setVegOnly(value);
//                     localStorage.setItem(VEG_MODE_KEY, JSON.stringify(value));
//                   }}
//                   sx={{
//                     "& .MuiSwitch-thumb": {
//                       bgcolor: vegOnly ? "#2e7d32" : "#ccc",
//                     },
//                   }}
//                 />
//               }
//             />
//             <SettingRow
//               icon={<NotificationsIcon sx={{ fontSize: 20, color: "#888" }} />}
//               label="Order Notifications"
//               action={
//                 <Switch
//                   size="small"
//                   checked={notifications}
//                   disabled
//                   onChange={(e) => setNotifs(e.target.checked)}
//                   sx={{
//                     "& .MuiSwitch-thumb": {
//                       bgcolor: notifications ? "#2e7d32" : "#ccc",
//                     },
//                   }}
//                 />
//               }
//             />
//             <SettingRow
//               icon={<LanguageIcon sx={{ fontSize: 20, color: "#888" }} />}
//               label="Language"
//               divider={false}
//               action={
//                 <Typography
//                   variant="caption"
//                   sx={{ color: "#aaa", fontSize: "0.75rem" }}
//                 >
//                   English
//                 </Typography>
//               }
//             />
//           </List>
//         </Paper>
//       </Box>

//       {/* ── Help / About ── */}
//       <Box sx={{ mx: 2, mt: 2 }}>
//         <Typography
//           variant="caption"
//           sx={{
//             color: "#aaa",
//             fontWeight: 700,
//             fontSize: "0.7rem",
//             textTransform: "uppercase",
//             letterSpacing: 0.8,
//             mb: 0.8,
//             display: "block",
//           }}
//         >
//           More
//         </Typography>
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: 2.5,
//             bgcolor: "white",
//             border: "1px solid #f0f0f0",
//             px: 1.5,
//           }}
//         >
//           <List disablePadding>
//             {[
//               {
//                 icon: (
//                   <HelpOutlineIcon sx={{ fontSize: 20, color: "#1565c0" }} />
//                 ),
//                 label: "Help & Support",
//                 page: "help",
//                 desc: "FAQs, contact & tickets",
//               },
//               {
//                 icon: (
//                   <StarBorderIcon sx={{ fontSize: 20, color: "#f59e0b" }} />
//                 ),
//                 label: "Rate This Restaurant",
//                 page: "rate",
//                 desc: "Share your feedback",
//               },
//               {
//                 icon: (
//                   <InfoOutlinedIcon sx={{ fontSize: 20, color: "#7b1fa2" }} />
//                 ),
//                 label: "About",
//                 page: "about",
//                 desc: "Version, team & legal",
//                 divider: false,
//               },
//             ].map(({ icon, label, page, desc, divider }) => (
//               <React.Fragment key={label}>
//                 <ListItem
//                   sx={{
//                     px: 0,
//                     py: 1.2,
//                     cursor: "pointer",
//                     borderRadius: 1,
//                     "&:hover": { bgcolor: "#fafafa" },
//                     transition: "background 0.15s",
//                   }}
//                   onClick={() => openSubPage(page)}
//                 >
//                   <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           fontSize: "0.85rem",
//                           fontWeight: 600,
//                           color: "#1a1a1a",
//                         }}
//                       >
//                         {label}
//                       </Typography>
//                     }
//                     secondary={
//                       <Typography
//                         variant="caption"
//                         sx={{ fontSize: "0.7rem", color: "#aaa" }}
//                       >
//                         {desc}
//                       </Typography>
//                     }
//                   />
//                   <ArrowForwardIosIcon sx={{ fontSize: 13, color: "#ccc" }} />
//                 </ListItem>
//                 {divider !== false && <Divider sx={{ ml: 4.5 }} />}
//               </React.Fragment>
//             ))}
//           </List>
//         </Paper>
//       </Box>
//       {/* ── Snackbar for feedback ── */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={4000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%", borderRadius: 2 }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default AccountPage;

import {
  Box,
  Typography,
  Paper,
  Avatar,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Divider,
  IconButton,
  TextField,
  Collapse,
  Snackbar,
  Alert,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsIcon from "@mui/icons-material/NotificationsNoneOutlined";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOffOutlined";
import LanguageIcon from "@mui/icons-material/LanguageOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import VegIcon from "@mui/icons-material/GrassOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DownloadIcon from "@mui/icons-material/Download";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectRestaurantInfo } from "../../../redux/slices/publicSlice";

// Sub-pages
import HelpSupportPage from "./HelpSupportPage";
import RateAppPage from "./RateAppPage";
import AboutPage from "./AboutPage";

const STORAGE_KEY = "digital_manu_user_profile";
const VEG_MODE_KEY = "digital_manu_veg_only";
const NOTIF_SOUND_KEY = "rw_sound_notification_enabled";

const AccountPage = ({ restaurantId, onSubPageChange }) => {
  const restaurantInfo = useSelector(selectRestaurantInfo);

  // ── PWA Install State ──
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [installSuccess, setInstallSuccess] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Check if app is already installed
  const [isAppInstalled, setIsAppInstalled] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsAppInstalled(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallBanner(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    const installedHandler = () => {
      setIsAppInstalled(true);
      setShowInstallBanner(false);
      setSnackbarMessage("App installed successfully! 🎉");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    };

    window.addEventListener("appinstalled", installedHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) {
      setSnackbarMessage("Please use 'Add to Home Screen' from your browser menu");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      return;
    }

    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;

      if (outcome === "accepted") {
        setInstallSuccess(true);
        setShowInstallBanner(false);
        setSnackbarMessage("App installed successfully! 🎉");
        setSnackbarSeverity("success");
      } else {
        setSnackbarMessage("Installation cancelled");
        setSnackbarSeverity("info");
      }

      setDeferredPrompt(null);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Install error:", error);
      setSnackbarMessage("Unable to install. Please try from browser menu");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleDismissBanner = () => {
    setShowInstallBanner(false);
  };

  // ── Profile State ──
  const [profile, setProfile] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : { name: "", phone: "", address: "" };
    } catch {
      return { name: "", phone: "", address: "" };
    }
  });

  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(profile);
  const [vegOnly, setVegOnly] = useState(() => {
    try {
      const saved = localStorage.getItem(VEG_MODE_KEY);
      return saved ? JSON.parse(saved) : false;
    } catch {
      return false;
    }
  });

  // ⭐ Order Notification State (Default true ya localStorage se)
  const [notifications, setNotifs] = useState(() => {
    try {
      const saved = localStorage.getItem(NOTIF_SOUND_KEY);
      return saved !== null ? JSON.parse(saved) : true;
    } catch {
      return true;
    }
  });

  // ⭐ Notification Toggle Handler: Save to localStorage and notify TopBar immediately
  const handleNotificationChange = (e) => {
    const isChecked = e.target.checked;
    setNotifs(isChecked);
    localStorage.setItem(NOTIF_SOUND_KEY, JSON.stringify(isChecked));

    // Instant TopBar icon update
    window.dispatchEvent(
      new CustomEvent("order-notification-toggle", {
        detail: { enabled: isChecked },
      })
    );

    setSnackbarMessage(
      isChecked
        ? "Order notification sounds turned ON 🔔"
        : "Order notification sounds muted 🔕"
    );
    setSnackbarSeverity(isChecked ? "success" : "info");
    setSnackbarOpen(true);
  };

  // Sub-page routing
  const [activePage, setActivePage] = useState(null);

  const openSubPage = (page) => {
    setActivePage(page);
    onSubPageChange?.(page, closeSubPage);
  };
  const closeSubPage = () => {
    setActivePage(null);
    onSubPageChange?.(null);
  };

  const handleSave = () => {
    setProfile(draft);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
    setEditing(false);
  };

  const initials = profile.name
    ? profile.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "?";

  const SettingRow = ({ icon, label, action, divider = true }) => (
    <>
      <ListItem sx={{ px: 0, py: 1.2 }}>
        <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
        <ListItemText
          primary={
            <Typography
              variant="body2"
              sx={{ fontSize: "0.85rem", fontWeight: 500, color: "#333" }}
            >
              {label}
            </Typography>
          }
        />
        {action}
      </ListItem>
      {divider && <Divider sx={{ ml: 4.5 }} />}
    </>
  );

  // ── Sub-page render ──
  if (activePage === "help") return <HelpSupportPage onBack={closeSubPage} />;
  if (activePage === "rate") return <RateAppPage onBack={closeSubPage} />;
  if (activePage === "about") return <AboutPage onBack={closeSubPage} />;

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 2 }}>
      {/* ── Install App Banner ── */}
      {showInstallBanner && !isAppInstalled && (
        <Paper
          elevation={2}
          sx={{
            mx: 2,
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            background: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <InstallMobileIcon sx={{ color: "white", fontSize: 28 }} />
            <Box>
              <Typography
                sx={{
                  color: "white",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                }}
              >
                Install Digital Menu App
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: "0.7rem",
                }}
              >
                Get faster access & offline support
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Button
              size="small"
              onClick={handleDismissBanner}
              sx={{
                color: "rgba(255,255,255,0.7)",
                minWidth: "auto",
                p: 0.5,
                "&:hover": { color: "white" },
              }}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleInstall}
              startIcon={<DownloadIcon />}
              sx={{
                bgcolor: "white",
                color: "#FF6B00",
                fontWeight: 700,
                fontSize: "0.75rem",
                textTransform: "none",
                borderRadius: 2,
                "&:hover": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              Install
            </Button>
          </Box>
        </Paper>
      )}

      {/* ── Profile Card ── */}
      <Box
        sx={{
          bgcolor: "white",
          px: 2,
          pt: 3,
          pb: 3,
          borderBottom: "1px solid #f0f0f0",
          mt: showInstallBanner && !isAppInstalled ? 1 : 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            sx={{
              width: 60,
              height: 60,
              bgcolor: "#2e7d32",
              fontSize: "1.3rem",
              fontWeight: 700,
            }}
          >
            {initials}
          </Avatar>
          {!editing ? (
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, fontSize: "1rem" }}
              >
                {profile.name || "Set your name"}
              </Typography>
              {profile.phone && (
                <Typography variant="caption" sx={{ color: "#888" }}>
                  {profile.phone}
                </Typography>
              )}
              <Box>
                {profile.address && (
                  <Typography variant="caption" sx={{ color: "#888" }}>
                    {profile.address}
                  </Typography>
                )}
              </Box>
            </Box>
          ) : (
            <Box
              sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}
            >
              <TextField
                size="small"
                placeholder="Your name"
                value={draft.name}
                onChange={(e) => setDraft({ ...draft, name: e.target.value })}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    fontSize: "0.85rem",
                    "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
                  },
                }}
              />
              <TextField
                size="small"
                placeholder="Phone number"
                value={draft.phone}
                onChange={(e) => setDraft({ ...draft, phone: e.target.value })}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    fontSize: "0.85rem",
                    "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
                  },
                }}
              />
              <TextField
                size="small"
                placeholder="Your Address"
                value={draft.address}
                onChange={(e) =>
                  setDraft({ ...draft, address: e.target.value })
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    fontSize: "0.85rem",
                    "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
                  },
                }}
              />
            </Box>
          )}
          {!editing ? (
            <IconButton
              size="small"
              onClick={() => {
                setEditing(true);
                setDraft(profile);
              }}
              sx={{ bgcolor: "#f5f5f5", "&:hover": { bgcolor: "#ebebeb" } }}
            >
              <EditIcon sx={{ fontSize: 18, color: "#555" }} />
            </IconButton>
          ) : (
            <Box sx={{ display: "flex", gap: 0.5 }}>
              <Button
                size="small"
                onClick={() => {
                  setEditing(false);
                  setDraft(profile);
                }}
                sx={{
                  borderRadius: 1.5,
                  textTransform: "none",
                  color: "#888",
                  fontSize: "0.78rem",
                }}
              >
                Cancel
              </Button>
              <Button
                size="small"
                variant="contained"
                onClick={handleSave}
                sx={{
                  borderRadius: 1.5,
                  bgcolor: "#2e7d32",
                  "&:hover": { bgcolor: "#1b5e20" },
                  textTransform: "none",
                  fontSize: "0.78rem",
                }}
              >
                Save
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      {/* ── Preferences ── */}
      <Box sx={{ mx: 2, mt: 2 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#aaa",
            fontWeight: 700,
            fontSize: "0.7rem",
            textTransform: "uppercase",
            letterSpacing: 0.8,
            mb: 0.8,
            display: "block",
          }}
        >
          Preferences
        </Typography>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2.5,
            bgcolor: "white",
            border: "1px solid #f0f0f0",
            px: 1.5,
          }}
        >
          <List disablePadding>
            <SettingRow
              icon={<VegIcon sx={{ fontSize: 20, color: "#2e7d32" }} />}
              label="Veg Only Mode"
              action={
                <Switch
                  size="small"
                  checked={vegOnly}
                  onChange={(e) => {
                    const value = e.target.checked;
                    setVegOnly(value);
                    localStorage.setItem(VEG_MODE_KEY, JSON.stringify(value));
                  }}
                  sx={{
                    "& .MuiSwitch-thumb": {
                      bgcolor: vegOnly ? "#2e7d32" : "#ccc",
                    },
                  }}
                />
              }
            />

            {/* ⭐ Order Notification Sound Active/Mute Switch */}
            <SettingRow
              icon={
                notifications ? (
                  <NotificationsIcon sx={{ fontSize: 20, color: "#2e7d32" }} />
                ) : (
                  <NotificationsOffIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
                )
              }
              label={notifications ? "Order Notifications (Sound ON)" : "Order Notifications (Muted)"}
              action={
                <Switch
                  size="small"
                  checked={notifications}
                  onChange={handleNotificationChange}
                  sx={{
                    "& .MuiSwitch-thumb": {
                      bgcolor: notifications ? "#2e7d32" : "#d32f2f",
                    },
                  }}
                />
              }
            />

            <SettingRow
              icon={<LanguageIcon sx={{ fontSize: 20, color: "#888" }} />}
              label="Language"
              divider={false}
              action={
                <Typography
                  variant="caption"
                  sx={{ color: "#aaa", fontSize: "0.75rem" }}
                >
                  English
                </Typography>
              }
            />
          </List>
        </Paper>
      </Box>

      {/* ── Help / About ── */}
      <Box sx={{ mx: 2, mt: 2 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#aaa",
            fontWeight: 700,
            fontSize: "0.7rem",
            textTransform: "uppercase",
            letterSpacing: 0.8,
            mb: 0.8,
            display: "block",
          }}
        >
          More
        </Typography>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2.5,
            bgcolor: "white",
            border: "1px solid #f0f0f0",
            px: 1.5,
          }}
        >
          <List disablePadding>
            {[
              {
                icon: (
                  <HelpOutlineIcon sx={{ fontSize: 20, color: "#1565c0" }} />
                ),
                label: "Help & Support",
                page: "help",
                desc: "FAQs, contact & tickets",
              },
              {
                icon: (
                  <StarBorderIcon sx={{ fontSize: 20, color: "#f59e0b" }} />
                ),
                label: "Rate This Restaurant",
                page: "rate",
                desc: "Share your feedback",
              },
              {
                icon: (
                  <InfoOutlinedIcon sx={{ fontSize: 20, color: "#7b1fa2" }} />
                ),
                label: "About",
                page: "about",
                desc: "Version, team & legal",
                divider: false,
              },
            ].map(({ icon, label, page, desc, divider }) => (
              <React.Fragment key={label}>
                <ListItem
                  sx={{
                    px: 0,
                    py: 1.2,
                    cursor: "pointer",
                    borderRadius: 1,
                    "&:hover": { bgcolor: "#fafafa" },
                    transition: "background 0.15s",
                  }}
                  onClick={() => openSubPage(page)}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          color: "#1a1a1a",
                        }}
                      >
                        {label}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="caption"
                        sx={{ fontSize: "0.7rem", color: "#aaa" }}
                      >
                        {desc}
                      </Typography>
                    }
                  />
                  <ArrowForwardIosIcon sx={{ fontSize: 13, color: "#ccc" }} />
                </ListItem>
                {divider !== false && <Divider sx={{ ml: 4.5 }} />}
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Box>

      {/* ── Snackbar for feedback ── */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{ bottom: 70 }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%", borderRadius: 2 }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AccountPage;